import revive_payload_client_4sVQNw7RlN from "/var/deploy-agents/tgi/_work/1/s/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/deploy-agents/tgi/_work/1/s/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/deploy-agents/tgi/_work/1/s/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/var/deploy-agents/tgi/_work/1/s/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/var/deploy-agents/tgi/_work/1/s/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/deploy-agents/tgi/_work/1/s/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/var/deploy-agents/tgi/_work/1/s/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/var/deploy-agents/tgi/_work/1/s/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/var/deploy-agents/tgi/_work/1/s/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/deploy-agents/tgi/_work/1/s/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_AOuQ1DYzjk from "/var/deploy-agents/tgi/_work/1/s/node_modules/@sidebase/nuxt-auth/dist/runtime/plugin.mjs";
import primevue_plugin_egKpok8Auk from "/var/deploy-agents/tgi/_work/1/s/.nuxt/primevue-plugin.mjs";
import plugin_client_8fz26Kfk5j from "/var/deploy-agents/tgi/_work/1/s/node_modules/nuxt-primevue/dist/runtime/plugin.client.mjs";
import i18n_yfWm7jX06p from "/var/deploy-agents/tgi/_work/1/s/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_AUP22rrBAc from "/var/deploy-agents/tgi/_work/1/s/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.js";
import fontawesome_klhsrycjcK from "/var/deploy-agents/tgi/_work/1/s/plugins/fontawesome.js";
import mobile_TeE7st402c from "/var/deploy-agents/tgi/_work/1/s/plugins/mobile.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_AOuQ1DYzjk,
  primevue_plugin_egKpok8Auk,
  plugin_client_8fz26Kfk5j,
  i18n_yfWm7jX06p,
  plugin_AUP22rrBAc,
  fontawesome_klhsrycjcK,
  mobile_TeE7st402c
]